var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConcierge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-concierge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.929,4.184v.887L9.685,2.613a5.694,5.694,0,0,0-5.442,0L0,5.083v-.9C0,1.486,1.474,0,4.171,0H9.757C12.454,0,13.929,1.486,13.929,4.184Z",
    transform: "translate(7.035 2.334)",
    fill: "#222227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.29,3.422l-.168-.084L14.492,2.4,11.112.45a3.917,3.917,0,0,0-3.644,0L4.088,2.391l-1.63.959-.216.108C.144,4.873,0,5.136,0,7.4V12.82c0,2.266.144,2.529,2.29,3.98l5.178,2.985a3.541,3.541,0,0,0,1.822.444,3.7,3.7,0,0,0,1.822-.444l5.226-3.021c2.11-1.414,2.242-1.666,2.242-3.944V7.4C18.58,5.136,18.436,4.873,16.29,3.422Zm-3.656,6.629-.731.9a.868.868,0,0,0-.192.563l.072,1.151a.757.757,0,0,1-1.115.815L9.6,13.048a1.062,1.062,0,0,0-.611,0l-1.067.42a.754.754,0,0,1-1.115-.815L6.881,11.5a.868.868,0,0,0-.192-.563l-.743-.887a.761.761,0,0,1,.432-1.319l1.115-.288a.966.966,0,0,0,.479-.36l.623-.959a.762.762,0,0,1,1.39,0l.623.959a.949.949,0,0,0,.479.36l1.115.288A.761.761,0,0,1,12.634,10.051Z",
    transform: "translate(4.71 6.067)",
    fill: "#222227"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConcierge);
export default __webpack_public_path__ + "static/media/icon-concierge.494e9dfa263cccce1f654a2fb6595a90.svg";
export { ForwardRef as ReactComponent };